import APIService from '../api.service';

export const List = (params) => {
  return APIService.get(`/v01/shops`, {
    params: {
      per_page: params?.perPage,
      page: params?.page,
      keyword: params?.keyword,
      brand_id: params?.brand_id,
      region_id: params?.region_id,
      warehouse_id: params?.warehouse_id,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/shops`, body, config);
};

export const Put = (id, body, config = {}) => {
  return APIService.put(`/v01/shops/${id}`, body, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/shops/${id}`, config);
};

export const Active = () => {
  return APIService.get(`/v01/active-shops`);
};

const ShopService = {
  List,
  Create,
  Put,
  Delt,
  Active
};
export default ShopService;
